export default unsafe =>
    unsafe
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
        // the following is supposed to be escaped as well, but it affects a lot of ingredients
        // .replace(/\//g, '&#x2F;')
